export default "__VITE_ASSET__BPe_AX$2__"